<template>
  <div class="container container-vende-tu-auto text-center">

    <div class="row justify-content-center">

      <div class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center">
        <img class="step-desktop" src="../assets/imgs/desktop/vende_tu_auto_paso2_web.png" alt="AUTOCOM" />
        <img class="step-tablet" src="../assets/imgs/tablet/vende_tu_auto_paso2_tablet.png" alt="AUTOCOM" />
        <img class="step-mobile" src="../assets/imgs/mobile/vende_tu_auto_paso2_mobile.png" alt="AUTOCOM" />
      </div>

      <div class="container container-info">

        <div class="container-vende-view">
          <b-overlay :show="show1" variant="transparent" opacity="0.87" spinner-variant="danger" rounded="sm">

            <div class="content-va">
              <div class="mrg-datosv">
                <div class="marcaModeloAño text-uppercase">{{ año }} <span class="black">{{ marca.toUpperCase() }} {{
                    modelo.toUpperCase() }}</span></div>
                <div class="versionColorKm mb-5 text-uppercase">{{ version }} <span class="pipe">|</span> {{ color }}
                  <span class="pipe">|</span> {{ kmComputedString }} KM
                </div>
              </div>
            </div>

            <div>
              <div v-if="this.codigoMobile == false">
                <b-form class="container" v-if="showForm">
                  <div class="content-va">
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <h5>
                          <label for="validationDefault01" class="form-label texto-vehiculo2">*Nombre(s)</label>
                        </h5>
                        <input v-model="nombre" type="text" class="-input" id="validationDefault01"
                          placeholder="Escribe tu nombre" maxlength="20" required />
                      </div>
                      <div class="col-md-6 col-sm-12 apellido">
                        <h5>
                          <label for="validationDefault02" class="form-label texto-vehiculo2">*Apellidos</label>
                        </h5>
                        <input v-model="apellidos" type="text" class="-input" id="validationDefault02"
                          placeholder="Escribe tus apellidos" maxlength="30" required />
                      </div>
                      <div class="col-md-6 col-sm-12 margin-vehiculo">
                        <h5>
                          <label class="form-label texto-vehiculo2"
                            :class="{textoError: (this.telefonoError == false)}">*Teléfono móvil</label>
                        </h5>
                        <img src="../assets/imgs/ico-tooltip.svg" class="imgToolTip-t" @click="openTooltip" alt="" />
                        <div class="descripcion-tooltipT d-none">
                          <p class="text-left p-tooltip"> El número telefónico debe ser a 10 dígitos. </p>
                        </div>
                        <input v-model="telefono" type="text" @keyup="validaError()" class="-input"
                          :class="{inputError: (this.telefonoError == false)}" id="validationDefault03"
                          placeholder="55 0000 0000" maxlength="10"
                          onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                          pattern="[0-9]+" required />
                        <label class="mensajeError" v-if="this.telefonoError == false">Número de teléfono no
                          valido</label>
                      </div>
                      <div class="col-md-6 col-sm-12 margin-vehiculo">
                        <h5>
                          <label class="form-label texto-vehiculo2"
                            :class="{textoError: (this.mailError == false)}">*E-mail</label>
                        </h5>
                        <img src="../assets/imgs/ico-tooltip.svg" class="imgToolTip-e" @click="openTooltip2" alt="" />
                        <div class="descripcion-tooltipE d-none">
                          <p class="text-left p-tooltip"> El formato correcto del e-mail debe incluir el signo @. </p>
                        </div>
                        <input v-model="mail" type="email" @keyup="validaError2()" class="-input"
                          :class="{inputError: (this.mailError == false)}" id="validationDefault04"
                          placeholder="tucorreo@correo.com" required />
                        <label class="mensajeError" v-if="this.mailError == false">Correo electrónico no valido</label>
                      </div>

                      <div class="row justify-content-md-center mt-3" v-if="this.errorvaloracion == true">
                        <div class="col col-lg-12 mrg-error">
                          <b-alert :show="errorvaloracion" variant="dark">
                            {{this.errormessage}}
                          </b-alert>
                        </div>
                      </div>

                      <div class="text-center col-sm-12 campo-terminos margin-terminos desktop terminos">
                        <label class="legales">
                          Al hacer click en <span class="text-bold">SIGUIENTE</span> acepto los <a
                            class="text-my-own-color liga" href="https://www.autocom.mx/terminos-y-condiciones.html"
                            target="_blank">Términos y Condiciones</a> y el <a class="text-my-own-color liga"
                            href="https://www.autocom.mx/aviso-de-privacidad.html" target="_blank">Aviso de Privacidad
                          </a>
                        </label>
                      </div>

                      <div class="text-center col-sm-12 campo-terminos margin-terminos tablet terminos">
                        <label class="legales">
                          Al hacer click en <span class="text-bold">SIGUIENTE</span> acepto los <a
                            class="text-my-own-color liga" href="https://www.autocom.mx/terminos-y-condiciones.html"
                            target="_blank">Términos y Condiciones</a> y el <a class="text-my-own-color liga"
                            href="https://www.autocom.mx/aviso-de-privacidad.html" target="_blank">Aviso de Privacidad
                          </a>
                        </label>
                      </div>

                    </div>
                    <div class="controls row">
                      <div class="col-md-6 col-sm-12  order-md-2 left">
                        <button class="-btn-continue continue" disabled v-if="!formBool">SIGUIENTE</button>
                        <button class="-btn-continuar continue" @click.prevent="inicio()" v-else>SIGUIENTE</button>
                      </div>
                      <div class="col-md-6 col-sm-12  order-md-1 right">
                        <button type="button" @click.prevent="cancelar()" class="button-secondary">
                          REGRESAR
                        </button>
                      </div>
                    </div>
                  </div>

                  <p class="texto-oferta mt-2">
                    Conoce los documentos que necesitas para vender tu auto, <span style="" class="enlace"
                      @click="documentacion()">haz clic aquí</span>
                  </p>

                </b-form>
              </div>

              <div v-if="this.codigoMobile == true" class="justify-content-md-center">
                <h4 class="codigoVerificacion">Por seguridad te hemos enviado por <strong
                    class="black">Whatsapp</strong> al teléfono y por <strong class="black">mensaje</strong> al correo
                  registrados el código de verificación.</h4>
                <div class="wrpr-alert">
                  <b-alert :show="dismissCountDown" class="modal-minutes" @dismiss-count-down="countDownChanged">
                    El código vence en <span style="margin-left: 5px; margin-right: 5px;" id="contadorId"></span>minutos
                  </b-alert>

                  <b-alert v-if="this.caduca === true" show class="modal-minutes">
                    Tu código de seguridad ha caducado.
                  </b-alert>

                  <b-alert v-if="this.vencido === true" show class="modal-minutes">
                    Tu código de seguridad ha vencido, debes generar uno nuevo.
                  </b-alert>

                  <b-alert v-if="this.error === true" show variant="danger">
                    Tu código de seguridad es incorrecto.
                  </b-alert>
                </div>

                <b-row class="justify-content-md-center">
                  <b-col class="text-center rounded">
                    <b-form v-if="showToken">

                      <div class="container container-minutes text-center mrg-cv">
                        <div class="row row-cols-4">
                          <div class="col">

                            <b-form-input v-if="dispMobile===false" id="input-1" class="modal-sms-code" v-model="uno" type="text" placeholder=" "
                              maxlength="1"
                              onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-2').focus(); return false;}"
                              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                              required autofocus></b-form-input>
                            <b-form-input v-if="dispMobile===true" id="input-1" class="modal-sms-code" v-model="uno" type="number" placeholder=" "
                              maxlength="1"
                              onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-2').focus(); return false;}"
                              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                              required autofocus></b-form-input>
                          </div>
                          <div class="col">
                            <b-form-input v-if="dispMobile===false" id="input-2" class="modal-sms-code" v-model="dos" type="text" placeholder=" "
                              maxlength="1"
                              onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-3').focus(); return false;}"
                              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                              required></b-form-input>

                            <b-form-input v-if="dispMobile===true" id="input-2" class="modal-sms-code" v-model="dos" type="number" placeholder=" "
                              maxlength="1"
                              onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-3').focus(); return false;}"
                              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                              required></b-form-input>
                          </div>
                          <div class="col">
                            <b-form-input v-if="dispMobile===false" id="input-3" class="modal-sms-code" v-model="tres" type="text" placeholder=" "
                              maxlength="1"
                              onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-4').focus(); return false;}"
                              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                              required></b-form-input>
                            <b-form-input v-if="dispMobile===true" id="input-3" class="modal-sms-code" v-model="tres" type="number" placeholder=" "
                              maxlength="1"
                              onkeyup="javascript:if(this.value.length >= 1) {document.getElementById('input-4').focus(); return false;}"
                              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                              required></b-form-input>
                          </div>
                          <div class="col">
                            <b-form-input v-if="dispMobile===false" id="input-4" class="modal-sms-code" v-model="cuatro" type="text"
                              placeholder=" " maxlength="1"
                              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                              required></b-form-input>
                            <b-form-input v-if="dispMobile===true" id="input-4" class="modal-sms-code" v-model="cuatro" type="number"
                              placeholder=" " maxlength="1"
                              onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                              required></b-form-input>
                          </div>
                        </div>
                      </div>

                      <div class="desktop mt-4">
                        <button class="btn-resend-link" @click.prevent="generaCodigo()">
                          REENVIAR CÓDIGO
                        </button>
                      </div>
                      <div class="row">

                        <div class="col-12 mt-3 col-md-6 col-sm-12 left   order-md-2 order-lg-2">
                          <button style="" class="-btn-confirm" disabled v-if="!codeBool">
                            CONFIRMAR
                          </button>
                          <button style="" class="-btn-confirm" @click.prevent="siguiente()" v-else>
                            CONFIRMAR
                          </button>
                        </div>
                        <div class="col-12 col-md-6 col-sm-12 order-md-1 order-lg-1 right">
                          <button style="margin-top: 16px;" class="button-secondary" @click.prevent="salirCodigo()">
                            REGRESAR
                          </button>
                        </div>
                      </div>

                    </b-form>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>

    <b-modal v-model="modalCancelacion" size="lg" style="width: 100%; z-index: 99999000 !important;" hide-header
      hide-footer>
      <b-row cols="1" class="justify-content-md-center">
        <div class="col-sm-12 text-center">
          <img class='icono-alert' src="../assets/imgs/icono-alert.svg">
          <p class="modal-title mt-2">Lo sentimos, no fue posible generar una inspección para tu vehículo.</p>
        </div>

        <div class="text-center" style="margin-top: 25px;">
          <div class="marcaModeloAño">{{ año }} <span class="black">{{ marca.toUpperCase() }} {{ modelo.toUpperCase()
              }}</span></div>
          <div class="versionColorKm">{{ version }} <span class="pipe">|</span> {{ color }} <span class="pipe">|</span>
            {{ kmComputedString }} KM</div>
        </div>

        <div class="col-sm-12 text-center" style="margin-top: -15px;">
          <p class="modal-texto">Te invitamos a que generes una nueva oferta, busques una Agencia cercana a ti y acudas
            para buscar una oferta o nos llames al tel <a href="tel:8007112886">800-711-2886</a> y con gusto te
            ayudaremos.</p>

          <p class="modal-error">{{errorCalculo}}</p>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-6 mt-4 text-right order-2 order-sm-2 order-md-2 order-lg-1">
          <button class="-btn-confirm" @click.prevent="cancelarSolicitud()">
            NUEVA OFERTA
          </button>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-6 mt-4 text-left order-1 order-sm-1 order-md-1 order-lg-2">
          <button class="button-secondary" @click.prevent="cerrarCancelar()">
            BUSCAR AGENCIAS
          </button>
        </div>

      </b-row>
      <b-row>&nbsp;</b-row>
    </b-modal>

    <b-modal v-model="modalErrorConexion" size="lg" style="width: 100%" hide-header hide-footer>
      <b-row cols="1" class="content-modal justify-content-md-center">

        <div class="col-sm-12 text-center">
          <div class="modal-title mt-5">ERROR EN NUESTRO SISTEMA</div>

          <img class="ico-inspeccion" src="../assets/imgs/error_varios_icon.svg" alt="AUTOCOM" />

          <div class="lamentamos mt-3">
            Nuestro servicio está presentando errores, por el<br> momento no es posible realizar la operación, inténtalo
            <br> más tarde. <br> <span class="msnError">{{this.mensajeError1}}</span>
          </div>
        </div>

        <div class="text-center mt-4">
          <div class="controls">
            <button class="" @click.prevent="cerrarModal()">
              CERRAR
            </button>
          </div>
        </div>
      </b-row>
    </b-modal>

  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "Vendedor",

  components: {},

  data() {
    return {

      //server: 'https://srv-autocheck.autocomseminuevos.com/api',

      

      // serverAnalizador: 'https://qa-api-analizador.autocom.mx/api',
      //server: 'https://dev-srv-valoraciones.autocom.mx/api',


      /*server: 'https://qa-api-analizador.autocom.mx/api',
      serverAutoCheck: 'https://qa-api-autocheck.autocom.mx/api',
      serverComunicaciones: 'https://qa-comunicaciones.autocom.mx/api',
      creatioService: 'https://qa-creatioservice.autocom.mx/api',
      iframe: 'qa-vendetuauto.autocomseminuevos.com',
      serverNotificaciones: 'https://srv-notificaciones.autocom.mx/api',*/
      
      twillioservice: 'https://twilioservice.autocom.mx',

      server: process.env.VUE_APP_SERVER_ANALIZADOR,
      serverAutoCheck: process.env.VUE_APP_SERVER_AUTOCHECK,
      serverComunicaciones: process.env.VUE_APP_SERVER_COMUNICACIONES,
      creatioService: process.env.VUE_APP_CREATIO_SERVICE,
      iframe: process.env.VUE_APP_IFRAME,
      serverNotificaciones: process.env.VUE_APP_SERVER_NOTIFICACIONES,
      twillioservice: process.env.VUE_APP_TWILIO_SERVICE,

      
      show1: false,
      idvaloration: "",
      marca: sessionStorage.getItem("marca"),
      modelo: sessionStorage.getItem("modelo"),
      año: sessionStorage.getItem("anio"),
      version: sessionStorage.getItem("version"),
      color: sessionStorage.getItem("color"),
      kilometraje: sessionStorage.getItem("kilometraje"),
      precio_sugerido: sessionStorage.getItem("precioSolicitado"),
      noOferta: sessionStorage.getItem("noOferta"),
      seguimiento: sessionStorage.getItem("seguimiento"),
      ofertaMin: "",
      ofertaMax: "",
      offer_consignment: "",
      offer: "",
      offer_day: "",
      folio: "",
      observaciones: "",
      showForm: true,
      uno: "",
      dos: "",
      tres: "",
      cuatro: "",
      showToken: true,
      modalErrorConexion: false,
      mensajeError1: "",
      modalCancelacion: false,
      modalCodigoV: false,
      codigoMobile: false,
      codigoReserva: "",
      error: false,
      caduca: false,
      vencido: false,
      errorvaloracion: false,
      errormessage: 'Error',
      //dismissSecs: 300,
      dismissSecs: 300,
      dismissCountDown: 0,
      nombre: '',
      apellidos: '',
      telefono: '',
      telefonoError: true,
      mail: '',
      segmento: '',
      clasificacion: '',
      mailError: true,
      codeBool: false,
      formBool: false,
      terminos: false,
      aviso: false,
      localidad: '',
      tipoTel: '',
      compania: '',
      lada: '',

      bpmcsrf: '',
      ValCookie: '',
      estatus: '',
      validezVa: '',
      errorCalculo: '', 
      flag:0,
      dispMobile:false,
    };
  },

  methods: {

    isMobile(){
      
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      //return check;
      this.dispMobile=check;
   },

    inicio(){
      this.show1 = true;
      this.validez();
      this.email(this.mail);
    },

    openTooltip(){
      const tooltip = document.querySelector('.descripcion-tooltipT')
      tooltip.classList.toggle('d-none')
    },

    openTooltip2(){
      const tooltip = document.querySelector('.descripcion-tooltipE')
      tooltip.classList.toggle('d-none')
    },

    cargarToken(){
        let user = {username: "vendetuauto@autocom.mx", password: "Desarrollo123$"};
        axios.post(this.serverNotificaciones + "/token/login", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenMensaje", response.data.token);
          //this.tokenCreatio();
          this.tokenAutoCheck();
        })
        .catch((error) => {
          // this.mensajeError1 = 'EACT';
          // this.modalErrorConexion = true;
          this.snifferError(error.message, 'Notificaciones');
          console.log('error api notificaciones -->', error.message);
        });
    },

    tokenAutoCheck() {
      let user = { usuario: "autocom_seminuevos", password: "invarart2022Semi" };
      axios.post(this.serverAutoCheck + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenAutoCheck", response.data.token);
        })
        .catch((error) => {
          // this.mensajeError1 = 'EACT';
          // this.modalErrorConexion = true;
          this.snifferError(error.message, 'AutoCheck');
          console.log('error api notificaciones -->', error.message);
        });
    },

    cerrarModal(){

      this.modalErrorConexion = false;

    },

    tokenComunicaciones(){
        let user = {usuario: "Comunicaciones", password: "C0mun1c4c10n35"};
        axios.post(this.serverComunicaciones + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenComunicacion", response.data.token);
        }).catch((error) => {
          //this.snifferError(error,'Comunicaciones');
           this.mensajeError1 = 'ECOTK';
           this.modalErrorConexion = true;
           console.log('Error en el servicio de comunicaciones ...',error.message)
        });
    },

    /*tokenCreatio(){
        let user = {usuario: "CreatioService", password: "Cr34t1053rv1c3"};
        axios.post(this.creatioService + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenCreatio", response.data.token);
        }).catch((error) => {
          // this.mensajeError1 = 'ECTKN';
          // this.modalErrorConexion = true;
        this.snifferError(error.message, 'Creatio');
        console.log('Error al generar Token Creatio -->',error.message);
        });
    },*/

    salirCodigo(){
      this.codigoMobile = false;
    },

    validaError(){
      if(this.telefono.length > 1){
        this.telefonoError = true;
      }
    },

    validaError2(){
      if(this.mail.length > 1){
        this.mailError = true;
      }
    },

    secondsToString(seconds) {
      var hour = Math.floor(seconds / 3600);
      hour = (hour < 10)? '0' + hour : hour;
      var minute = Math.floor((seconds / 60) % 60);
      minute = (minute < 10)? '0' + minute : minute;
      var second = seconds % 60;
      second = (second < 10)? '0' + second : second;
      document.getElementById('contadorId').innerHTML = minute + ':' + second;
      return minute + ':' + second;
    },

    async siguiente() {
      this.codigoMemoria = this.uno + this.dos + this.tres + this.cuatro;
      this.codigo = sessionStorage.getItem("codigoReserva");
      //console.log('Memoria -->',this.codigoMemoria+' - '+this.codigo);
      if (this.codigo == this.codigoMemoria) {
        this.modalCodigoV = false;
        this.caduca = false;
        this.error = false;
        this.vencido = false;
        setTimeout(() => {
          
          //this.valuacionAuto();
          //console.log('Oferta -->',this.noOferta);
          if (this.noOferta == 'false') {
            this.enviaOferta();
            clearInterval(this.intervalos);
            this.$router.push({ path: "/Oferta" });
          } else {
            clearInterval(this.intervalos);
            this.$router.push({ path: "/noOferta" });
          }

        }, 150);
      } else if (this.codigo === 'No Number') { 
        this.caduca = false;
        this.error = false;
        this.vencido = true;
        this.onReset();
      }
      else {
        this.caduca = false;
        this.error = true;
        this.vencido = false;
        this.onReset();
      }
    },

    valuacionAuto() {

      //console.log('Tipo Oferta -->',this.noOferta);

      if (this.noOferta == 'false') {
        let body = {
          /*sp: "calculoauto",
          idbrand: sessionStorage.getItem("idmarca"),
          idmodel: sessionStorage.getItem("idmodelo"),
          idyear: sessionStorage.getItem("idanio"),
          idtrim: sessionStorage.getItem("idversion"),*/
          vehicleid:sessionStorage.getItem("idvehicle"),
          mileage: Math.floor(sessionStorage.getItem("kilometraje")),
          host: "VA",
          fuente: "BI"
        };

        //console.log('body -->', body);

        axios.post(
          this.server + "/calculo",
          body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
          .then((response) => {
            //this.errormessage = response.data.error;
            this.errormessage = response.data.data.clasificacion;
            //console.log('Respuesta -->', response.data.data);

            if (this.errormessage === 'D' || response.data.data.offer === 0) {
              this.show1 = false;
              this.codigoMobile = false;
              this.modalCancelacion = true;
              this.errorCalculo='';

            } else {
              this.errorCalculo='';
/*<<<<<<< HEAD
              this.offer = response.data.data.offer;
              this.offer_day = response.data.data.offer_day;
              this.offer_consignment = response.data.data.offer_consignment;
              this.folio = response.data.data.invoice;
              this.segmento = response.data.data.generales.segmento;
              this.clasificacion = response.data.data.generales.clasificacion;
=======*/
              this.offer = response.data.data.Calculo.Offer;
              this.offer_day = response.data.data.Calculo.Offer_day;
              this.offer_consignment = response.data.data.CalculoConsignacion.offer_consignment;
              this.folio = response.data.data.invoice;
              console.log("FOLIO "+response.data.data.invoice)
              console.log("FOLIO "+this.folio)
              this.segmento = ''; //response.data.data.generales.segmento;

              this.clasificacion = response.data.data.clasificacion;


              this.ofertaMin = (Number(this.offer) - (this.offer * .10));
              //this.ofertaMax = (Number(this.offer) + (this.offer * .02));
              this.ofertaMax = this.offer;
/*<<<<<<< HEAD
              this.flag=response.data.data.generales.calculo.flag;
=======*/
              this.flag=response.data.data.flag;


              console.log('Oferta Min -->', this.ofertaMin);
              console.log('Oferta Max -->', this.ofertaMax);

              sessionStorage.setItem("nombre", this.nombre);
              sessionStorage.setItem("apellidos", this.apellidos);
              sessionStorage.setItem("email", this.mail);
              sessionStorage.setItem("telefono", this.telefono);
              sessionStorage.setItem("folio", this.folio);
              sessionStorage.setItem("oferta", response.data.data.Calculo.Offer);
              sessionStorage.setItem("offer_day", response.data.data.CalculoCompra.Offer);
              sessionStorage.setItem("offer_consignment", response.data.data.CalculoConsignacion.offer_consignment);
              sessionStorage.setItem("fecha_validez", this.validezVa);
              sessionStorage.setItem("ofertaMin", this.ofertaMin);
              sessionStorage.setItem("ofertaMax", this.ofertaMax);
              sessionStorage.setItem("fuente", "www.seminuevos.com");
              this.crearValuacion();
              console.log('datos creados');
            }

          })
               .catch((error) => {

                console.log("MENSAJE: "+error);


                if(error.response.status===400 || error.response.status===500){
                  this.errorCalculo=error.response.data.message
                  this.show1 = false;
                  this.codigoMobile = false;
                  this.modalCancelacion = true;
                }else{
                  this.show1 = false;
                  // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
                  this.errorvaloracion = true;
                  this.mensajeError1 = 'EVANOV';
                  this.modalErrorConexion = true;
                  this.snifferError(error.message, 'Valoraciones');
                  console.log(JSON.stringify(error));
                  console.log('Error en el servicio de valoraciones ...',error.message)
                }
               });
      } else {
        sessionStorage.setItem("nombre", this.nombre);
        sessionStorage.setItem("apellidos", this.apellidos);
        sessionStorage.setItem("email", this.mail);
        sessionStorage.setItem("telefono", this.telefono);
        this.errorvaloracion = false;

        if (this.seguimiento === 'creatio') {
          //this.keysCreatio();      
          this.CreatioLeads()    
        } else {
          console.log('Atendido por asesor')
        }

        if(this.flag===3 || this.flag===4){
          this.show1 = false;
          this.codigoMobile = false;
          this.modalCancelacion = true;
          this.errorCalculo='';
        }else{

          this.generaCodigo();
          this.estatus = 'No Oferta';
        }
        //this.enviaOferta();
        //this.codigoMobile = true;

      }
    },

    crearValuacion(e) {

      if(this.precio_sugerido === ''){
        this.precio_sugerido = 0;
      }

      console.log('Crear valuacion');
      let body = {
        nombre: this.nombre + ' ' + this.apellidos,
        email: this.mail,
        regimenFiscal: "",
        vin: "",
        idbrand: sessionStorage.getItem("idmarca"),
        brand: this.marca,
        idmodel: sessionStorage.getItem("idmodelo"),
        model: this.modelo,
        idyear: sessionStorage.getItem("idanio"),
        year: this.año,
        line: this.modelo,
        idtrim: sessionStorage.getItem("idversion"),
        trim: this.version,
        vehiclescol: "",
        ext_color: this.color,
        int_color: "",
        transmition: "",
        kilometers: this.kilometraje,
        refacturated: 0,
        nombre_tarjeta: "",
        vestidura: "",
        rin: 0,
        rin_tipo: "",
        placas: "",
        fila_asientos: 0,
        estado: "",
        nombre_asesor: "",
        precio_sugerido: this.precio_sugerido,
        tipo: "",

        //prod
        //rid_status: 5,

        //dev
        rid_status: 5,

        rid_sucursal: 51,

        //prod
        //rid_usuarios: 170,

        //dev
        rid_usuarios: 170,

        rfc: "",
        curp: "",
        mobile: this.telefono,
        chat: "",
        phone: this.telefono,
        //id_catalogo_cesvi: 0,
        owners: 0,
        comentarios: this.folio,
        segmento: this.segmento,
        oferta: this.offer,
        oferta_hoy: this.offer_day,
        oferta_consignacion: this.offer_consignment,
        oferta_rango_minimo: this.ofertaMin,
        oferta_rango_maximo: this.ofertaMax,
        clasificacion: this.clasificacion,
        PVP: 0,
        Utilidad: 0,
        tipo_valuacion: 2,
        fuente_valoracion: '',
        bandera:this.flag,
      };

      //console.log('Body -->',body);

      axios.post(this.serverAutoCheck + "/valuacion/create", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          //console.log("Respuesta -->", response.data.data[0].valuacion_id);
          //Tomar el id cliente de esta api
          this.idvaloration = response.data.data[0].valuacion_id;
          sessionStorage.setItem("idcliente", response.data.data[0].cliente_id);
          sessionStorage.setItem("idvaloration", this.idvaloration);
          this.agregarprogreso();
          this.asignaSucursal();
        })
        .catch((error) => {
          // this.show1 = false;
          // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.mensajeError1 = 'EVACV';
          this.modalErrorConexion = true;
          this.show1 = false;
          this.snifferError(error.message, 'Valoraciones');
          console.log('Error en el servicio de valoraciones ...',error.message);
        });
    },

    agregarprogreso() {
      console.log("Agregar Progreso");
      let body = {
        rid_valuacion: this.idvaloration,
        payload: "[{\"id\":\"1\",\"nombre\":\"Registro cliente / vehículo\",\"estatus\":\"0\"},{\"id\":\"2\",\"nombre\":\"Generalidades del vehículo\",\"estatus\":\"0\"},{\"id\":\"3\",\"nombre\":\"Inspección general\",\"estatus\":\"0\"},{\"id\":\"4\",\"nombre\":\"Guía de fotografías\",\"estatus\":\"0\"},{\"id\":\"5\",\"nombre\":\"Formato OCRA\",\"estatus\":\"0\"},{\"id\":\"6\",\"nombre\":\"inspección del vehículo.\",\"estatus\":\"0\"}]",
        activo: 1
      };
      axios.post(this.serverAutoCheck + "/valuacion_mod_progreso/create", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          this.progresso = true;
        })
        .catch((error) => {
          // this.show1 = false;
          // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.mensajeError1 = 'EVAAP';
          this.modalErrorConexion = true;
          this.show1 = false;
          this.snifferError(error.message, 'Valoraciones');
          console.log('Error en el servicio de valoraciones ...', error.message);
        });
    },

    asignaSucursal() {
      console.log("Asignar sucursal");
      let body = {
        id: this.idvaloration,
        rid_sucursal_contratos: 51
      };

      //console.log('Body -->',body);

      axios.post(this.serverAutoCheck + "/valuacion/update_sucursalContratos", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          //console.log("Respuesta asigna sucursal -->", response);
          this.guardarValuacionFinal();
        })
          .catch((error) => {
            // this.show1 = false;
            // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
            this.mensajeError1 = 'EVAAS';
            this.modalErrorConexion = true;
            this.show1 = false;
          this.snifferError(error.message, 'Valoraciones');
          console.log('Error en el servicio de valoraciones ...', error.message);
          });
    },

    guardarValuacionFinal() {
      console.log("Valuación Final");
      let body = {
        id: this.idvaloration,

        //QA
        //rid_usuario: 101,

        //Prod
        rid_usuario: 170,

        oferta: this.offer,
        oferta_hoy: this.offer_day,
        oferta_consignacion: this.offer_consignment,
        oferta_seleccionada: 0,
        monto_demerito_extra: 0,
        fuente: '',
        interes_compra: '',
        clasificacion: this.clasificacion,
        reserva_peritaje: 0,
        oferta_guardada: 0,
        otra_fuente: "NA",
        valoracion_virtual: 1
      };

      //console.log('Body -->',body);

      axios.post(this.serverAutoCheck + "/valuacion/guardar_valuacionFinal", body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenAutoCheck"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          if(this.flag===3 || this.flag===4){
            this.show1 = false;
            this.codigoMobile = false;
            this.modalCancelacion = true;
            this.errorCalculo='';
          }else{
            this.errorvaloracion = false;
            //console.log('Entrando Creatio -->', response);
            this.generaCodigo();
            if (this.seguimiento === 'creatio') {
              //this.keysCreatio();
              this.CreatioLeads()
            } else {
              console.log('Atendido por asesor')
            }
            this.estatus = 'Oferta Inicial';
          }
        })
        .catch((error) => {
          // this.show1 = false;
          // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
            this.mensajeError1 = 'EVAVF';
            this.modalErrorConexion = true;
            this.show1 = false;
          this.snifferError(error.message, 'Valoraciones');
          console.log('Error en el servicio de valoraciones ...', error.message);
        });
    },

    cancelar() {
      // this.modalCancelacion = true;
      window.history.go(-1);
    },

    cerrarCancelar() {
      this.modalCancelacion = false;
      //window.history.go(-1);
      window.top.location.href="https://www.autocomseminuevos.com/hours.aspx"
    },

    cancelarSolicitud(){
      this.modalCancelacion=false
      //window.history.go(-2);
      this.$router.push({ path: "/" });
    },

    cerrar() {
      this.modalCodigoV = false;
    },

    generaCodigo() {
      this.show1 = false;
      this.codigoMobile = true;
      //console.log('Entrando -->',this.codigoMobile);

      this.caduca = false;
      this.error = false;
      this.vencido = false;
      this.codigoReserva = Math.floor(1000 + Math.random() * 9000);
      sessionStorage.setItem("codigoReserva", this.codigoReserva);
      this.onReset();
      this.showAlert();
      this.enviaWhats();
      this.enviaMail();
      return this.codigo;
    },

    email(valor){

      var res=/^([\da-z_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
      if(!res.exec(valor)){
        this.show1 = false;
        this.mailError = false;
      }
      else {
        this.validaEmail();
      };

    },

    validaEmail(){
      console.log("Servicio Interno mail");

      axios.get(this.serverComunicaciones + "/infoCorreo/"+this.mail,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenComunicacion"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          this.statusMail = response.data.status;
          if (this.statusMail === 200) {
            this.validaTelefono();
          }
          if (this.statusMail === 201) {
            // Correo de Lista Negra
            this.show1 = false;
            this.mailError = false;
          }
          if (this.statusMail === 204) {
             this.servicioEmail()
          }
        })
        .catch((error) => {
          this.show1 = false;
          // this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.mensajeError1 = 'ECVE';
          this.modalErrorConexion = true;
          console.log('Error en el servicio de comunicaciones',error.message);
        });
    },

    servicioEmail() {
    console.log('Servicio Externo mail');
    const apiKey = '23a0f100-816c-4fc1-91ff-75c0a6c17f9b';
      axios.get("https://validacion.email/query/validate/"+this.mail+"?token="+apiKey)
      .then((response) => {
        this.syntax = response.data.response.syntax;
        if (this.syntax === 'correct') {
          this.guardaEmail();
          this.errorvaloracion = false;
        } else {
          this.show1 = false;
          this.mailError = false;
        }
      }).catch(error=>{
        if(error.response.data.error_message === "El correo tiene algunas inconsistencias"){
          this.show1 = false;
          this.mailError = false;
        } else {
            this.snifferError(error.message, 'Correo Externo');
            console.log('Error en el servicio de correo externo', error.message);
          // this.show1 = false;
          // this.mensajeError1 = 'ECVEE';
          // this.modalErrorConexion = true;
        }

      });
    },

    guardaEmail(){
      console.log("Guardar mail");

      let body = {
          correo: this.mail,
          propietario: this.nombre +' '+this.apellidos,
        };

      axios.post(this.serverComunicaciones + "/agregarCorreo/",body,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenComunicacion"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          //console.log(response);
          this.validaTelefono();
        })
        .catch((error) => {
          this.show1 = false;
          this.mensajeError1 = 'ECGM';
          this.modalErrorConexion = true;
          console.log('Error en el servicio de comunicaciones', error.message);
        });
    },

    validaTelefono(){

      if (this.telefono.length === 10) {
        console.log("Servicio Interno teléfono");

        axios.get(this.serverComunicaciones + "/infoTelefono/"+this.telefono,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenComunicacion"),
              "Content-Type": "application/json",
            },
          }
        )
          .then((response) => {
            this.statusTel = response.data.status;
            if(this.statusTel === 200){
              this.valuacionAuto();
            } else {
              // SERVICIO PARA CONSULTAR A IFETEL
              //this.servicioTelefono();
              this.valuacionAuto();
            }
          })
          .catch((error) => {
            this.show1 = false;
            this.mensajeError1 = 'ECVT';
            this.modalErrorConexion = true;
            console.log('Error en el servicio de comunicaciones', error.message);
          });
      } else {
        this.show1 = false;
        this.telefonoError = false;
      }
    },

    servicioTelefono(){
    console.log('Servicio Externo Telefono');
      let body = {
          telefono: this.telefono,
          };

      axios.post(this.serverComunicaciones + "/consultaTel/",body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenComunicacion"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {

          this.validaTel = response.status;
          if (this.validaTel == 200){
            this.localidad = response.data.registrationCity;
            this.tipoTel = response.data.phoneType;
            this.compania = response.data.phoneCompany;
            this.lada = response.data.lada;
            this.agregarTelefono();
          } else {
            this.show1 = false;
            this.telefonoError = false;
          }
        })
        .catch((error) => {
          /*this.show1 = false;
          this.mensajeError1 = 'ECVTE';
          this.modalErrorConexion = true;
          console.log('Error en el servicio de comunicaciones', error.message);*/
          this.valuacionAuto();
        });
    },

    agregarTelefono(){
      console.log('Agregar Telefono');
      let body = {
          localidad: this.localidad,
          tipo: this.tipoTel,
          compania: this.compania,
          lada: this.lada,
          telefono: this.telefono,
          propietario: this.nombre+' '+this.apellidos
      };

      axios.post(this.serverComunicaciones + "/agregarTelefono",body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenComunicacion"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {

          this.statusAdd = response.status;
          //console.log(this.statusAdd);
          if (this.validaTel == 200){
            this.valuacionAuto();
          }
        })
        .catch((error) => {
          this.show1 = false;
          this.mensajeError1 = 'ECAT';
          this.modalErrorConexion = true;
          console.log('Error en el servicio de comunicaciones', error.message);
        });

    },

    countDownChanged(dismissCountDown) {

      this.dismissCountDown = dismissCountDown
      if (this.dismissCountDown == 0) {
        this.onReset();
        this.caduca = true;
        this.error = false;
        this.codigoReserva = 'No Number';
        sessionStorage.setItem("codigoReserva", this.codigoReserva);
      } else {
        this.secondsToString(this.dismissCountDown)
      }
    },

    showAlert() {
      this.overlay = false;
      this.dismissCountDown = this.dismissSecs;
    },

    onReset() {
      this.uno = "";
      this.dos = "";
      this.tres = "";
      this.cuatro = "";
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    enviaWhats(){
      console.log('Enviando WhatsApp');
      this.mensajeCodigo = "AUTOCOM te informa que tu código de confirmación es "+this.codigoReserva;
      let body = {
          from: "MGc74a1535c4981448d75077f816409ceb",
          to: this.telefono,
          templateId: "HXe6d77a4e33f66d8acdfd0ce9ca4f5102",
          parametros: "{'1': '"+this.codigoReserva+"'}"
        };

      axios.post(this.twillioservice + "/envia-whatsapp-plantilla",body
      ).then((response) => {
          console.log('Mensaje WhatsApp--->', response.status);
      }).catch(error => {
        console.log('Algo salio mal WhatsApp--->',error);
        //this.snifferError(error.message,'Twilio');
        // this.show1 = false;
        // this.mensajeError1 = 'ETEWA';
        // this.modalErrorConexion = true;
      });
    },
    
    enviaMail(){
      let mail = {
          user: "vendetuauto@autocom.mx",
          aplication:"Vende tu Auto",
          subject:"CODIGO DE VERIFICACION AUTOCOM",
          EmailsTo: [{email:this.mail}],
          EmailsToCc: [{emailCc:""},
          {emailCc:""}],
          body:`
          <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
      <html>
      <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
      <!-- utf-8 works for most cases -->
      <meta name="viewport" content="width=device-width">
      <!-- Forcing initial-scale shouldn't be necessary -->
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <!-- Use the latest (edge) version of IE rendering engine -->
      <title>Codigo verificacion</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
      <!-- The title tag shows in email notifications, like Android 4.4. -->

      <!-- Please use an inliner tool to convert all CSS to inline as inpage or external CSS is removed by email clients -->
      <!-- important in CSS is used to prevent the styles of currently inline CSS from overriding the ones mentioned in media queries when corresponding screen sizes are encountered -->

      <!-- CSS Reset -->
      <style type="text/css">
      /* What it does: Remove spaces around the email design added by some email clients. */
            /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
      html, body {
        margin: 0 !important;
        padding: 0 !important;
        height: 100% !important;
        width: 100% !important;
      }
      /* What it does: Stops email clients resizing small text. */
      * {
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
      }
      /* What it does: Forces Outlook.com to display emails full width. */
      .ExternalClass {
        width: 100%;
      }
      /* What is does: Centers email on Android 4.4 */
      div[style*="margin: 16px 0"] {
        margin: 0 !important;
      }
      /* What it does: Stops Outlook from adding extra spacing to tables. */
      table, td {
        mso-table-lspace: 0pt !important;
        mso-table-rspace: 0pt !important;
      }
      /* What it does: Fixes webkit padding issue. Fix for Yahoo mail table alignment bug. Applies table-layout to the first 2 tables then removes for anything nested deeper. */
      table {
        border-spacing: 0 !important;
        border-collapse: collapse !important;
        table-layout: fixed !important;
        margin: 0 auto !important;
        margin-block-end: 5px;
        margin-block-start: 5px;
      }
      table table table {
        table-layout: auto;
      }
      /* What it does: Uses a better rendering method when resizing images in IE. */
      img {
        -ms-interpolation-mode: bicubic;
      }
      /* What it does: Overrides styles added when Yahoo's auto-senses a link. */
      .yshortcuts a {
        border-bottom: none !important;
      }
      /* What it does: Another work-around for iOS meddling in triggered links. */
      a {
              color: #AF0F2B;
              text-decoration: underline;
              font-weight: 700;
            }

      .cabeza2{
        font-family: Arial,helvetica,sans-serif;
      font-style: italic;
      font-weight: 800;
      font-size: 22px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      }
      .unidad{
      font-family:  Arial,helvetica,sans-serif;
      font-weight: 800;
      font-size: 28px;
      line-height: 0px;
      text-align: center;
      color: #000000;
      padding-top:20px;
      padding-bottom: 5px;
      }
      .anio{
      font-family:  Arial,helvetica,sans-serif;
      font-weight: 800;
      font-size: 28px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      padding-top:20px;
      padding-bottom: 5px;
      }
      .folio{
      font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 22px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      }
      .mejor{
      font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      padding-top: 25px;
      padding-bottom: 2px;
      }
      .oferta{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 34px;
      line-height: 150%;
      align-items: center;
      text-align: center;
      color: #AF0F2B;
      }
      .div_naranja{
        background-color: #E63E19; 

      }
      .validez{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      align-items: center;
      text-align: center;
      color: #696969;
      }
      .inspeccion{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 150.1%;
      align-items: center;
      text-align: center;
      color: #696969;
      }
      </style>

      <!-- Progressive Enhancements -->
      <style type="text/css">
      /* What it does: Hover styles for buttons */
      .button-td, .button-a {
        transition: all 100ms ease-in;
      }
      .button-td:hover, .button-a:hover {
        background: #A50932 !important;
        border-color: #A50932 !important;
      }

      /* Media Queries */
      @media screen and (max-width: 480px) {
      /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
      .fluid, .fluid-centered {
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }
      /* And center justify these ones. */
      .fluid-centered {
        margin-left: auto !important;
        margin-right: auto !important;
      }
      /* What it does: Forces table cells into full-width rows. */
      .stack-column, .stack-column-center {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        direction: ltr !important;
      }
      /* And center justify these ones. */
      .stack-column-center {
        text-align: center !important;
      }
      /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
      .center-on-narrow {
        text-align: center !important;
        display: block !important;
        margin-left: auto !important;
        margin-right: auto !important;
        float: none !important;
      }
      table.center-on-narrow {
        display: inline-block !important;
      }
      }
      </style>
      </head>
      <body width="100%" bgcolor="#e0e0e0" style="margin: 0;" yahoo="yahoo">
      <table cellpadding="0" cellspacing="0" border="0" height="100%" width="100%" bgcolor="#e0e0e0" style="border-collapse:collapse;">
        <tr>
          <td><center style="width: 100%;">
              
              <!-- Visually Hidden Preheader Text : BEGIN -->
              <div style="display:none;font-size:1px;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;mso-hide:all;font-family: sans-serif;"> Esta es tu código de validación AUTOCOM </div>
              <!-- Visually Hidden Preheader Text : END -->
              
              <div style="max-width: 600px;"> 
                <!--[if (gte mso 9)|(IE)]>
                  <table cellspacing="0" cellpadding="0" border="0" width="680" align="center">
                  <tr>
                  <td>
                  <![endif]--> 
                
                <!-- Email Header : BEGIN -->
                <div style="width:100%">

                  <img style="max-width:100%" src="https://qa-vendetuauto.autocomseminuevos.com/img/mail/head.jpg" alt="" bgcolor="#ffffff">
                 
                </div>

                <!-- Email Header : END --> 
                
                <!-- Email Body : BEGIN -->
                <table cellspacing="0" cellpadding="0" border="0" align="center" bgcolor="#ffffff" width="100%" style="max-width: 600px;">
                  
                <!-- 1 Column Text : BEGIN -->
                  <tr>
                    <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                        <tr>
                          <td style="padding: 30px;padding-bottom:0px; text-align: center;"> 
                           
                           
                           <p class="cabeza2"style="font-family:Arial,Helvetica,sans-serif;font-size: 22px;line-height:150%">
                            <span style="color:#696969; font-style: italic;font-weight: 800;line-height: 150%;">Este es tu código de confirmación</span>
                            
                           </p>
                          

                            
                           
                            <p>
                              <span class="oferta"style="font-family:Arial,Helvetica,sans-serif; margin-block-start: 5px;margin-block-end:5px;font-size: 34px;color:#AF0F2B;text-align: center"><B>${this.codigoReserva}</B></span>
                            <span class="validez" style="text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969"><br>
                              Este código es válido por 5 minutos
                            </span>
                          </p>

                            </td>
                            </tr>
                            
                        <tr>
                          <td>
                            
                           
                            <hr size="1px" color="#D9D9D9" width="90%">
                                  <p class="validez" style="padding-top:20px;padding-bottom:25px;text-align: center;font-family:Arial,Helvetica,sans-serif;font-size: 14px;color: #696969">
                                    Si necesitas ayuda comunicate a: <br><a href="mailto:atenciononline@autocom.mx" style="color:#AF0F2B">atenciononline@autocom.mx</a> o al tel: <a href="tel:8000220015" style="color:#AF0F2B">800 02 20015</a>
                                  </p>
                          </td>
                        </tr>
                      </table></td>
                  </tr>

          
                <!--[if (gte mso 9)|(IE)]>
                  </td>
                  </tr>
                  </table>
                  <![endif]--> 
              </div>
            </center></td>
        </tr>
      </table>
      </body>
      </html>
          `};

      axios.post(this.serverNotificaciones + "/emailSend",mail, {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("tokenMensaje"),
          'Content-Type': 'application/json',
        },
        }).then((response) => {
            console.log('Mail --->', response.status);
        }).catch(error => {
            console.log('Algo salio mal mail--->',error.message);
            // this.show1 = false;
            // this.mensajeError1 = 'ENEM';
          // this.modalErrorConexion = true;
        this.snifferError(error.message, 'Notificaciones');
        });
    },

     enviaOferta(){

       this.ofertamail = this.formatPrice(this.offer);
       this.foliomail = sessionStorage.getItem("folio");
       this.idvaloration = sessionStorage.getItem("idvaloration");

       console.log("OFERTA MIN "+this.ofertaMin);
       console.log("REDONDEO: "+this.formatPrice(this.formatValue(this.ofertaMin)))
       console.log("OFERTA MAX "+this.ofertaMax);
       console.log("REDONDEO: "+this.formatPrice(this.formatValue(this.ofertaMax)))

       let mail = {
           user: "vendetuauto@autocom.mx",
           aplication:"Vende tu Auto",
           subject:"AUTOCOM TIENE UNA OFERTA PARA TI",
           EmailsTo: [{email:this.mail}],
           EmailsToCc: [{emailCc:""},
           {emailCc:""}],
           body:`
      <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
      <html>
      <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
      <!-- utf-8 works for most cases -->
      <meta name="viewport" content="width=device-width">
      <!-- Forcing initial-scale shouldn't be necessary -->
      <meta http-equiv="X-UA-Compatible" content="IE=edge">
      <!-- Use the latest (edge) version of IE rendering engine -->
      <title>Codigo verificacion</title>
        <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">
      <!-- The title tag shows in email notifications, like Android 4.4. -->

      <!-- Please use an inliner tool to convert all CSS to inline as inpage or external CSS is removed by email clients -->
      <!-- important in CSS is used to prevent the styles of currently inline CSS from overriding the ones mentioned in media queries when corresponding screen sizes are encountered -->

      <!-- CSS Reset -->
      <style type="text/css">
      /* What it does: Remove spaces around the email design added by some email clients. */
            /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
      html, body {
        margin: 0 !important;
        padding: 0 !important;
        height: 100% !important;
        width: 100% !important;
      }
      /* What it does: Stops email clients resizing small text. */
      * {
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
      }
      /* What it does: Forces Outlook.com to display emails full width. */
      .ExternalClass {
        width: 100%;
      }
      /* What is does: Centers email on Android 4.4 */
      div[style*="margin: 16px 0"] {
        margin: 0 !important;
      }
      /* What it does: Stops Outlook from adding extra spacing to tables. */
      table, td {
        mso-table-lspace: 0pt !important;
        mso-table-rspace: 0pt !important;
      }
      /* What it does: Fixes webkit padding issue. Fix for Yahoo mail table alignment bug. Applies table-layout to the first 2 tables then removes for anything nested deeper. */
      table {
        border-spacing: 0 !important;
        border-collapse: collapse !important;
        table-layout: fixed !important;
        margin: 0 auto !important;
      }
      table table table {
        table-layout: auto;
      }
      /* What it does: Uses a better rendering method when resizing images in IE. */
      img {
        -ms-interpolation-mode: bicubic;
      }
      /* What it does: Overrides styles added when Yahoo's auto-senses a link. */
      .yshortcuts a {
        border-bottom: none !important;
      }
      /* What it does: Another work-around for iOS meddling in triggered links. */
      a {
              color: #AF0F2B;
              text-decoration: underline;
              font-weight: 700;
            }

      .cabeza2{
        font-family: Arial,helvetica,sans-serif;
      font-style: italic;
      font-weight: 800;
      font-size: 22px;
      line-height: 22px;
      text-align: center;
      color: #696969;
      }
      .unidad{
      font-family:  Arial,helvetica,sans-serif;
      font-weight: 800;
      font-size: 28px;
      line-height: 0px;
      text-align: center;
      color: #000000;
      padding-top:20px;
      padding-bottom: 5px;
      }
      .anio{
      font-family:  Arial,helvetica,sans-serif;
      font-weight: 800;
      font-size: 28px;
      line-height: 0px;
      text-align: center;
      color: #696969;
      padding-top:20px;
      padding-bottom: 5px;
      }
      .folio{
      font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 22px;
      line-height: 0px;
      text-align: center;
      color: #696969;
      }
      .mejor{
      font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 150%;
      text-align: center;
      color: #696969;
      padding-top: 25px;
      padding-bottom: 2px;
      }
      .oferta{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 34px;
      line-height: 150%;
      align-items: center;
      text-align: center;
      color: #AF0F2B;
      }
      .div_naranja{
        background-color: #E63E19; 

      }
      .validez{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      align-items: center;
      text-align: center;
      color: #696969;
      }
      .inspeccion{
        font-family:  Arial,helvetica,sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 150.1%;
      align-items: center;
      text-align: center;
      color: #696969;
      }
      </style>

      <!-- Progressive Enhancements -->
      <style type="text/css">
      /* What it does: Hover styles for buttons */
      .button-td, .button-a {
        transition: all 100ms ease-in;
      }
      .button-td:hover, .button-a:hover {
        background: #A50932 !important;
        border-color: #A50932 !important;
      }

      /* Media Queries */
      @media screen and (max-width: 480px) {
      /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
      .fluid, .fluid-centered {
        width: 100% !important;
        max-width: 100% !important;
        height: auto !important;
        margin-left: auto !important;
        margin-right: auto !important;
      }
      /* And center justify these ones. */
      .fluid-centered {
        margin-left: auto !important;
        margin-right: auto !important;
      }
      /* What it does: Forces table cells into full-width rows. */
      .stack-column, .stack-column-center {
        display: block !important;
        width: 100% !important;
        max-width: 100% !important;
        direction: ltr !important;
      }
      /* And center justify these ones. */
      .stack-column-center {
        text-align: center !important;
      }
      /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
      .center-on-narrow {
        text-align: center !important;
        display: block !important;
        margin-left: auto !important;
        margin-right: auto !important;
        float: none !important;
      }
      table.center-on-narrow {
        display: inline-block !important;
      }
      }
      </style>
      </head>
      <body width="100%" bgcolor="#e0e0e0" style="margin: 0;" yahoo="yahoo">
      <table cellpadding="0" cellspacing="0" border="0" height="100%" width="100%" bgcolor="#e0e0e0" style="border-collapse:collapse;">
        <tr>
          <td><center style="width: 100%;">
              
              <!-- Visually Hidden Preheader Text : BEGIN -->
              <div style="display:none;font-size:1px;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;mso-hide:all;font-family: sans-serif;"> Esta es tu oferta AUTOCOM </div>
              <!-- Visually Hidden Preheader Text : END -->
              
              <div style="max-width: 600px;"> 
                <!--[if (gte mso 9)|(IE)]>
                  <table cellspacing="0" cellpadding="0" border="0" width="680" align="center">
                  <tr>
                  <td>
                  <![endif]--> 
                
                <!-- Email Header : BEGIN -->
                <div style="width:100%">

                  <img style="max-width:100%" src="https://qa-vendetuauto.autocomseminuevos.com/img/mail/head.jpg" alt="" bgcolor="#ffffff">
                 
                </div>

                <!-- Email Header : END --> 
                
                <!-- Email Body : BEGIN -->
                <table cellspacing="0" cellpadding="0" border="0" align="center" bgcolor="#ffffff" width="100%" style="max-width: 600px;">
                  
                <!-- 1 Column Text : BEGIN -->
                  <tr>
                    <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                        <tr>
                          <td style="padding: 30px;padding-bottom:0px; text-align: center;"> 
                            <h1 ><span style="font-family:Arial,Helvetica,sans-serif; font-weight: 800; font-size: 34px; line-height: 150%; text-align: center; color: #AF0F2B; padding-bottom: 5px;">¡FELICIDADES ${this.nombre.toUpperCase()}!</span></h1>
                            <p class="cabeza2"style="font-family:Arial,Helvetica,sans-serif;"><span style="color:#696969; font-style: italic;font-weight: 800;">Esta es la oferta que Autocom tiene para ti</span></p>
                            <p class="unidad"style="font-family:Arial,Helvetica,sans-serif;"><span class="anio">${this.año} </span>${this.marca} ${this.modelo} </p>
                            <p class="folio"style="font-family:Arial,Helvetica,sans-serif;">NO. DE OFERTA: ${this.foliomail}</p>
                            <p class="mejor" style="margin-block-end: 0.2em;font-family:Arial,Helvetica,sans-serif;">EL RANGO DE TU<BR>MEJOR OFERTA <b><span style="color:#000000">GARANTIZADA</span></b> ES</p>
                            </td>
                            </tr>
                            <tr>
                        
                          <td style="padding: 0px;" align="center">
                            
                            <table>
                              <tr>
                              
                              <td>
                                <p class="oferta"style="font-family:Arial,Helvetica,sans-serif; margin-block-start: 0.1em;margin-block-end:0.2em">DE <B>$ ${this.formatPrice(this.formatValue(this.ofertaMin))}.00*</B> A <B>$ ${this.formatPrice(this.formatValue(this.ofertaMax))}.00*</B></p>
                              </td>
                              <td>
                                
                              </td>
                            </tr>
                            </table>
                            
                          </td>
                        
                        </tr>
                        <tr>
                          <td>
                            <p class="validez" style="text-align: center;font-family:Arial,Helvetica,sans-serif;">
                              Esta oferta es válida hasta el <b>${this.validezVa}</b><br>
                              *El monto final de la oferta depende de la inspección del vehículo
                            </p>
                            <p style="padding-left:30px;padding-right: 30px; text-align: center;font-style: italic;font-family:Arial,Helvetica,sans-serif;" class="inspeccion"><b>Recuerda que para continuar con el proceso tu automóvil debe ser evaluado por nuestros especialistas, <a href="https://${this.iframe}/Oferta?vafolio=${this.idvaloration}&seguimiento=${this.seguimiento}" style="color:#AF0F2B">haz clic aquí</a> para agendar tu cita de inspección.</b>
                            </p>
                            <hr size="1px" color="#D9D9D9" width="90%">
                                  <p class="validez" style="padding-top:20px;padding-bottom:25px;text-align: center;font-family:Arial,Helvetica,sans-serif;">
                                    Si necesitas ayuda comunicate a: <br><a href="mailto:atenciononline@autocom.mx" style="color:#AF0F2B">atenciononline@autocom.mx</a> o al tel: <a href="tel:8000220015" style="color:#AF0F2B">800 02 20015</a>
                                  </p>
                          </td>
                        </tr>
                      </table></td>
                  </tr>

          
                <!--[if (gte mso 9)|(IE)]>
                  </td>
                  </tr>
                  </table>
                  <![endif]--> 
              </div>
            </center></td>
        </tr>
      </table>
      </body>
      </html>

           `};

       axios.post(this.serverNotificaciones + "/emailSend",mail, {
         headers: {
           Authorization: "Bearer " + sessionStorage.getItem("tokenMensaje"),
           'Content-Type': 'application/json',
         },
         }).then((response) => {
             console.log('Mail Oferta--->', response.status);
         }).catch(error => {
          console.log('Algo salio mal mail --->',error.message);
            // this.show1 = false;
            // this.mensajeError1 = 'ENEMO';
           // this.modalErrorConexion = true;
          this.snifferError(error.message, 'Notificaciones');
         });
     },

     /*keysCreatio(){

      console.log('Creando token creatio');

      let user = {
        usuario: "AutocomITConnector",
        contrasenia: "raFA89Hx2JCUkJA6GN#$NL"
      }

      axios.post(this.creatioService + '/creatioToken', user,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenCreatio"),
            "Content-Type": "application/json",
          },
        })
      .then(response =>{
        this.bpmcsrf = response.data.BPMCSRF;
        this.ValCookie = response.data.CookieVal;
        this.CreatioLeads();
      }).catch(error=>{
        // this.show1 = false;
        // this.mensajeError1 = 'ECGK';
        // this.modalErrorConexion = true;
          this.snifferError(error.message, 'Creatio');
          console.log('Error en el servicio de creatio', error.message);
      });

     },*/

     CreatioLeads(){

      console.log('Creando lead creatio');

      let data = {
        nombre: this.nombre,
        nombreContacto: this.nombre +' '+ this.apellidos,
        telefono: this.telefono,
        mail: this.mail,
        necesidad: "Toma",
        proveedor: "DealerOn",
        fuente: "www.seminuevos.com",
        aplicacion: "Vende Tu Auto",
        marca: sessionStorage.getItem("marca"),
        modelo: sessionStorage.getItem("modelo"),
        anio: sessionStorage.getItem("anio"),
        version: sessionStorage.getItem("version"),
        kms: sessionStorage.getItem("kilometraje"),
        costo: sessionStorage.getItem("precioSolicitado"),
        Oferta: sessionStorage.getItem("oferta"),
        OfertaConsignacion: sessionStorage.getItem("offer_consignment"),
        OfertadelDia: sessionStorage.getItem("offer_day"),
        TipoValuacion:"",
        AgenciaValuacion:"",
        FolioValuacion:"",
        FechaCitaValuacion:"",
        HoraCitaValuacion:"",
        Calle:"",
        Ciudad:"",
        Estado: "",
        CP:"",
        Colonia:"",
        NumExt:"",
        NumInt:"",
        color: this.color,
        precioDeseado: sessionStorage.getItem("precioSolicitado"),
        //BPMCSRF: this.bpmcsrf,
        //cookie: this.ValCookie
      }

      //console.log('JSON Data 1 -->', data);

      //axios.post(this.creatioService + '/VendeAuto', data,
      /**
       * Authorization:
              "Bearer " + sessionStorage.getItem("tokenCreatio"),
      */
      axios.post(this.creatioService + '/leads/autocom_creatio', data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(response => {
        console.log("IdCreatio", response.data.info.Id);
        sessionStorage.setItem("IdCreatio", response.data.info.Id);
        //this.AgregandoLeads();
        //this.mailCreatioLead();
        
      }).catch(error=>{
        // this.show1 = false;
        // this.mensajeError1 = 'ECGL';
        // this.modalErrorConexion = true;
          this.snifferError(error.message, 'Creatio');
          console.log('Error en el servicio de creatio', error.message);
      });

    },

     /*AgregandoLeads(){

      console.log('Agregando lead creatio');

      let data = {
        idcreatio: sessionStorage.getItem("IdCreatio"),
        nombre: this.nombre,
        apellidos: this.apellidos,
        telefono: this.telefono,
        mail: this.mail,
        fecha: sessionStorage.getItem("fechaCreatio"),
        aplicacion: "Vende tu Auto",
        estatus: this.estatus
      }

      axios.post(this.creatioService + '/addLead', data,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenCreatio"),
            "Content-Type": "application/json",
          },
        })
      .then(response =>{
        console.log('Lead Agregado');
        this.AgregandoIds();
      }).catch(error=>{
        // this.show1 = false;
        // this.mensajeError1 = 'ECAL';
        // this.modalErrorConexion = true;
          this.snifferError(error.message, 'Creatio');
        console.log('Error para agregar el info creatio en BD -->',error.message);
      });

      },

      AgregandoIds(){

      console.log('Agregando ids creatio');

      let data = {
        idcreatio: sessionStorage.getItem("IdCreatio"),
        idautocheck: sessionStorage.getItem("idvaloration"),
        idva: sessionStorage.getItem("folio"),
        nombre: this.nombre +' '+ this.apellidos,
      }

      //console.log('Agregar datos --> ',data);

      axios.post(this.creatioService + '/addDataVa', data,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenCreatio"),
            "Content-Type": "application/json",
          },
        })
      .then(response =>{
        console.log('Ids Agregados');
        this.mailCreatioLead();
      }).catch(error=>{
        // this.show1 = false;
        // this.mensajeError1 = 'ECAIDS';
        // this.modalErrorConexion = true;
          this.snifferError(error.message, 'Creatio');
        console.log('Error para agregar el id creatio en BD -->',error.message);
      });

      },*/

    mailCreatioLead(){
      console.log('Correo de lead de Creatio');

      let data = {
        cliente: this.nombre +' '+ this.apellidos,
        origen: 'Vende tu Auto',
        telefono: this.telefono,
        email: this.mail,
        marca: sessionStorage.getItem("marca"),
        anio: sessionStorage.getItem("anio"),
        modelo: sessionStorage.getItem("modelo"),
        version: sessionStorage.getItem("version"),
        agencia: 'N/A',
        vin: 'N/A',
        lead: sessionStorage.getItem("IdCreatio")
      }

      axios.post(this.serverComunicaciones + "/creatioVendeAuto",data,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenComunicacion"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          console.log('Correo enviado');
        })
        .catch((error) => {
          console.log('Error de correo comunicaciones --->',error.message);
        });

    },

    validez(){
      let d=new Date();
      d.setDate(d.getDate()+8);
      let a= d.toLocaleDateString('es-pa').split("/");
      this.validezVa = a[1]+"/"+a[0]+"/"+a[2];
      return a[1]+"/"+a[0]+"/"+a[2];
    },

    dateCreatio(){
      const date = new Date();
      const date2 = new Date().toString();
      const date3 = date2.substring(16,24)
      const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      sessionStorage.setItem("fechaOriginacion", output);
      sessionStorage.setItem("fechaCreatio", output+'T'+date3+'-00:00');
    },

    checkCode() {
      if (this.uno !== "" && this.dos !== "" && this.tres !== "" && this.cuatro !== "") {
        this.codeBool = true;
      } else {
        this.codeBool = false;
      }
    },

    checkForm() {
      if (this.nombre !== '' && this.apellidos !== '' && this.telefono !== '' && this.mail !== '') {
        this.formBool = true;
      } else {
        this.formBool = false;
      }
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatValue(value) {
      let val = Math.round(value / 100) * 100;
      return val
    },

    opendWindow(){
      clearInterval(this.intervalos);
      window.location.replace('/');
      //console.log('1');
    },

    tiempoActivo(){
      this.intervalos = setInterval(() => {
        this.opendWindow();
      },3600000);
    },

    documentacion() {
      sessionStorage.setItem("prev", "vendedor")
      setTimeout(() => {
        // window.open('/Documentos');
        this.$router.push({ path: "/Documentos" });
      }, 150);
    },

    snifferError(error, servicio){

      let data = {
        error: error,
        servicio: servicio,
      }


      axios.post(this.serverComunicaciones + "/snifferVa", data,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenComunicacion"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          console.log('Alerta enviada');
        })
        .catch((error) => {
          console.log('Error de alerta --->', error);
        });

    },

  },

  watch: {
    uno() {
      this.checkCode();
    },
    dos() {
      this.checkCode();
    },
    tres() {
      this.checkCode();
    },
    cuatro() {
      this.checkCode();
    },
    nombre() {
      this.checkForm();
    },
    apellidos() {
      this.checkForm();
    },
    telefono() {
      this.checkForm();
    },
    mail() {
      this.checkForm();
    }
  },

  computed: {
    kmComputedString() {
      let kmString = this.kilometraje.toString()
      let string_size = kmString.length;
      let kmArray = [];
      if (string_size % 3 == 0) {
        for (let i = 0; i < string_size / 3; i++)
          kmArray[i] = kmString.substr(i * 3, 3);
      } else if (string_size % 3 == 1) {
        kmArray[0] = kmString[0]
        kmString = kmString.substr(1);
        for (let i = 0; i < (string_size / 3) - 1; i++)
          kmArray[i + 1] = kmString.substr(i * 3, 3);
      } else {
        kmArray[0] = kmString.substr(0, 2)
        kmString = kmString.substr(2);
        for (let i = 0; i < (string_size / 3) - 1; i++)
          kmArray[i + 1] = kmString.substr(i * 3, 3);
      }
      let kmFinalString = "";
      kmArray.forEach(element => kmFinalString += element + ',');
      return kmFinalString.slice(0, kmFinalString.length - 1);
    },
  },

  created(){
    this.cargarToken();
    this.tokenComunicaciones();
    window.scrollTo(0,0);
    this.tiempoActivo();
    this.dateCreatio();
    this.isMobile();
  },

  onMounted(){
    window.scrollTo(0, 0)
  }
};
</script>

<style>


.modal-title.verificacion {
  margin-top: 15px;
}

.verification-numbers-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.verification-number-containers {
  width: 269px;
}

.motivoTextSelect {
  padding: 0 15%;
  text-align: left;
  width: 100%;
}

.motivoTextSelect select {
  display: block;
}

</style>